import React, { FC } from 'react'
import Icon from 'particles/Icon'
import { PLATFORM_ENUM } from 'services/api/constants'

const getIcon: Record<Exclude<PLATFORM_ENUM, PLATFORM_ENUM.OTHER>, JSX.Element> = {
    [PLATFORM_ENUM.IG]: <Icon size="16px" name={'instagramLogo'} color={'neutralActionActive'} />,
    [PLATFORM_ENUM.FB]: <Icon size="16px" name={'facebookLogo'} color={'neutralActionActive'} />,
    [PLATFORM_ENUM.TIKTOK]: <Icon size="16px" name={'tiktokLogo'} color={'neutralActionActive'} />,
    [PLATFORM_ENUM.YOUTUBE]: <Icon size="16px" name={'facebookLogo'} color={'neutralActionActive'} />,
    [PLATFORM_ENUM.TWITTER]: <Icon size="16px" name={'twitterLogo'} color={'neutralActionActive'} />,
    [PLATFORM_ENUM.THREADS]: <Icon size="16px" name={'threadsLogo'} color={'neutralActionActive'} />,
    [PLATFORM_ENUM.XIAOHONGSHU]: <Icon size="16px" name={'xiaohongshuLogo'} color={'neutralActionActive'} />,
}

type Props = {
    platform: Exclude<PLATFORM_ENUM, PLATFORM_ENUM.OTHER>
}

const SociSocialMediaPlatformIcon: FC<Props> = ({ platform }) => {
    return getIcon[platform]
}

export default SociSocialMediaPlatformIcon
